<script lang="ts">
	import Icon from "../molecules/Icon.svelte"

	export let klass = ''
	export let label = ''
	export let close: () => void
</script>

<span class="chip {klass}">
	<span class="chip-label">
		{ label }
	</span>
	{#if close}
		<span class="chip-close" on:click={close}>
			<Icon name="x" />
		</span>
	{/if}
</span>


<style lang="postcss">
	.chip {
		@apply py-2 px-3 bg-blue-400 text-white text-xs rounded-full inline-flex items-center;
		flex-basis: 100px;
	}

	.chip-label {

	}

	.chip-close {
		@apply ml-2 bg-white text-blue-400 rounded-full cursor-pointer;
	}
</style>